import { AvailabilityOverride } from './types.ts'
import { LANGUAGES } from '@boltenergy-be/shared'
import { DAY_OF_WEEK } from 'constants/datetime.ts'
import { parseBelgianTime } from 'utils/date.ts'

export const AVAILABILITY_OVERRIDES: AvailabilityOverride[] = [
  // Temporary FR override due to low FR care team availability (sick leave)
  {
    userType: 'consumer',
    start: parseBelgianTime('2026-03-24').startOf('day'),
    end: parseBelgianTime('2026-03-24').endOf('week'),
    dayOfWeek: [DAY_OF_WEEK.monday, DAY_OF_WEEK.tuesday, DAY_OF_WEEK.wednesday, DAY_OF_WEEK.thursday, DAY_OF_WEEK.friday], // Thursday and Friday
    message: {
      [LANGUAGES.FR]: "Aujourd'hui, nous sommes joignables jusqu'à 16h"
    }
  }
]
